import React from 'react';

/*
 *  @Description:   Stateless component that renders a Lock Icon signifying a password.
 */

const Lock = ( props ) => {

    return (<g id="path">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </g>
    )

};


export default Lock;

